// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"0cab812f","513":"9ce09cd3","703":"3538db6f","787":"921bac28"}[chunkId] + ".chunk.js";
};